const SET_ACTIVE_USE_CASES = 'SET_ACTIVE_USE_CASES'
const SET_IS_SIGNATURE_ACTIVE = 'SET_IS_SIGNATURE_ACTIVE'
const SET_IS_PROMOTION_ACTIVE = 'SET_IS_PROMOTION_ACTIVE'
const SET_HAS_RESPONSES = 'SET_HAS_RESPONSES'
const SET_CURRENT_REGISTRE = 'SET_CURRENT_REGISTRE'
const SET_CURRENT_PROMOTION_DATE_RANGE = 'SET_CURRENT_PROMOTION_DATE_RANGE'
const SET_CURRENT_SIGNATURE = 'SET_CURRENT_SIGNATURE'
const SET_CURRENT_PROMOTION = 'SET_CURRENT_PROMOTION'
const SET_CURRENT_REPONSES = 'SET_CURRENT_REPONSES'

const state = () => {
  return {
    activeUseCases: [],
    hasResponses: false,
    isSignatureActive: false,
    isPromotionActive: false,
    currentRegistre: {
      name: 'Courant',
      id: 'common',
      key: 1,
    },
    currentSignature: '',
    currentPromotion: '',
    currentPromotionDateRange: {
      start: '',
      end: '',
    },
    currentResponses: '',
  }
}

const mutations = {
  [SET_ACTIVE_USE_CASES]: (state, useCases) => {
    state.activeUseCases = useCases
  },
  [SET_HAS_RESPONSES]: (state, bool) => {
    state.hasResponses = bool
  },
  [SET_IS_SIGNATURE_ACTIVE]: (state, bool) => {
    state.isSignatureActive = bool
  },
  [SET_IS_PROMOTION_ACTIVE]: (state, bool) => {
    state.isPromotionActive = bool
  },
  [SET_CURRENT_REGISTRE]: (state, registre) => {
    state.currentRegistre = registre
  },
  [SET_CURRENT_PROMOTION_DATE_RANGE]: (state, dateRange) => {
    state.currentPromotionDateRange = dateRange
  },
  [SET_CURRENT_SIGNATURE]: (state, signature) => {
    state.currentSignature = signature
  },
  [SET_CURRENT_PROMOTION]: (state, promotion) => {
    state.currentPromotion = promotion
  },
  [SET_CURRENT_REPONSES]: (state, response) => {
    state.currentResponses = response
  },
}

const actions = {
  initActiveUseCases: ({ commit }, useCases) => {
    const activeUseCases = useCases.map(useCase => useCase.activity.key)
    commit(SET_ACTIVE_USE_CASES, activeUseCases)
  },
  updateActiveUseCases: ({ commit }, useCases) => {
    commit(SET_ACTIVE_USE_CASES, useCases)
  },
  updateHasResponses: ({ commit }, bool) => {
    commit(SET_HAS_RESPONSES, bool)
  },
  updateIsSignatureActive: ({ commit }, bool) => {
    commit(SET_IS_SIGNATURE_ACTIVE, bool)
  },
  updateIsPromotionActive: ({ commit }, bool) => {
    commit(SET_IS_PROMOTION_ACTIVE, bool)
  },
  updateCurrentRegistre: ({ commit }, registre) => {
    commit(SET_CURRENT_REGISTRE, registre)
  },
  updateCurrentSignature: ({ commit }, signature) => {
    commit(SET_CURRENT_SIGNATURE, signature)
  },
  updateCurrentPromotion: ({ commit }, promotion) => {
    commit(SET_CURRENT_PROMOTION, promotion)
  },
  updateCurrentPromotionDateRange: ({ commit }, bool) => {
    commit(SET_CURRENT_PROMOTION_DATE_RANGE, bool)
  },
  updateCurrentResponse: ({ commit }, response) => {
    commit(SET_CURRENT_REPONSES, response)
  },
  resetFilters: ({ commit }) => {
    commit(SET_IS_SIGNATURE_ACTIVE, false)
    commit(SET_IS_PROMOTION_ACTIVE, false)
    commit(SET_CURRENT_REGISTRE, {
      name: 'Courant',
      id: 'common',
      key: 1,
    })
    commit(SET_CURRENT_SIGNATURE, '')
    commit(SET_CURRENT_PROMOTION, '')
    commit(SET_CURRENT_PROMOTION_DATE_RANGE, {
      start: '',
      end: '',
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
